var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 20H6.66667V0H10.6667V20Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20H20V4H24V20Z",
    fill: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H4V9.33333H0V20Z",
    fill: "#1B1B1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.3333H24V24H0V21.3333Z",
    fill: "#1B1B1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 20H17.3333V16H13.3333V20Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.02181bf71db24f9769c92eab13e65213.svg";
export { ForwardRef as ReactComponent };